import { useState } from "react";
import { orgLogoUrl } from "../lib/api";

export function OrgLogo({ orgId, className = "h-8", testid = "org-logo" }) {
  const [ok, setOk] = useState(true);
  if (!orgId || !ok) return null;
  return <img data-testid={testid} src={orgLogoUrl(orgId)} alt="" onError={() => setOk(false)} className={`${className} w-auto max-w-[9rem] object-contain`} />;
}
